import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'siu-loader-block-ui',
  templateUrl: './loader-block-ui.component.html',
  styleUrls: [ './loader-block-ui.component.scss' ]
})
export class LoaderBlockUiComponent implements OnInit {

  @Input() show: boolean = false;
  @Input() target: any = undefined;


  constructor() { }

  ngOnInit() {
  }

}
